/* DRIP theme — Only Zips */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };
  const root = T.routes.root.endsWith('/') ? T.routes.root : T.routes.root + '/';
  const body = document.body;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || T.currency || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  function toast(msg, isError) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.toggle('toast--error', !!isError);
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const wrap = $('[data-header]');
    if (!wrap) return;
    const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-toggle]')) { body.classList.toggle('menu-open'); }
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      body.classList.toggle('search-open');
      if (body.classList.contains('search-open')) setTimeout(() => { const i = $('.search-overlay input'); i && i.focus(); }, 200);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { body.classList.remove('menu-open', 'search-open'); closeCart(); }
  });

  /* ---------- Reveal on scroll ---------- */
  let io;
  function initReveal(ctx = document) {
    const els = $$('[data-reveal], .line-mask[data-reveal-lines]', ctx);
    if (!('IntersectionObserver' in window) || reduced) { els.forEach((el) => el.classList.add('is-in')); return; }
    if (!io) {
      io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Parallax ---------- */
  function initParallax() {
    const els = $$('[data-parallax]');
    if (!els.length || reduced) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.parallax) || 0.15;
        const offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Drag-to-scroll rails ---------- */
  function initRails(ctx = document) {
    $$('[data-rail]', ctx).forEach((rail) => {
      if (rail.dataset.railInit) return;
      rail.dataset.railInit = '1';
      let down = false, startX = 0, startLeft = 0, moved = false;
      rail.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); }
        rail.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        setTimeout(() => rail.classList.remove('is-dragging'), 0);
      });
      rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      const section = rail.closest('[data-rail-section]') || rail.parentElement;
      const step = () => Math.max(rail.clientWidth * 0.8, 260);
      const prev = $('[data-rail-prev]', section), next = $('[data-rail-next]', section);
      prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));

      const bar = $('[data-rail-progress]', section);
      if (bar) {
        const upd = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          const vis = rail.clientWidth / rail.scrollWidth;
          const p = max > 0 ? vis + (1 - vis) * (rail.scrollLeft / max) : 1;
          bar.style.setProperty('--p', p.toFixed(3));
        };
        rail.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }

  /* ---------- Count-up stats ---------- */
  function initCounters() {
    const els = $$('[data-count-to]');
    if (!els.length) return;
    const run = (el) => {
      const target = parseFloat(el.dataset.countTo);
      const dec = (String(el.dataset.countTo).split('.')[1] || '').length;
      if (reduced || isNaN(target)) { el.textContent = el.dataset.countTo; return; }
      const dur = 1600, t0 = performance.now();
      const tick = (t) => {
        const k = Math.min(1, (t - t0) / dur);
        const eased = 1 - Math.pow(1 - k, 4);
        el.textContent = (target * eased).toFixed(dec);
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const obs = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { run(en.target); obs.unobserve(en.target); } }), { threshold: 0.6 });
    els.forEach((el) => obs.observe(el));
  }

  /* ---------- Age gate ---------- */
  function initAgeGate() {
    const gate = $('[data-age-gate]');
    if (!gate) return;
    const KEY = 'oz_age_ok';
    let ok = false;
    try { const v = localStorage.getItem(KEY); ok = v && Number(v) > Date.now(); } catch (e) {}
    if (ok || window.Shopify && Shopify.designMode && gate.dataset.hideInEditor === 'true') { gate.remove(); return; }
    gate.hidden = false;
    body.classList.add('age-gate-active');
    $('[data-age-yes]', gate).addEventListener('click', () => {
      const days = Number(gate.dataset.days) || 30;
      try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {}
      gate.classList.add('is-leaving');
      body.classList.remove('age-gate-active');
      setTimeout(() => gate.remove(), 800);
    });
    $('[data-age-no]', gate).addEventListener('click', () => {
      window.location.href = gate.dataset.redirect || 'https://www.google.com';
    });
    $('[data-age-yes]', gate).focus();
  }

  /* ---------- Cart ---------- */
  function openCart() {
    if (T.cartType !== 'drawer' || !$('#CartDrawer')) { window.location.href = T.routes.cart; return; }
    body.classList.add('cart-open');
    const c = $('[data-cart-close]', $('#CartDrawer'));
    c && setTimeout(() => c.focus(), 300);
  }
  function closeCart() { body.classList.remove('cart-open'); }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  async function refreshCart(open) {
    try {
      const res = await fetch(`${root}?sections=cart-drawer`);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#CartDrawer');
        const cur = $('#CartDrawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          updateCount(Number(fresh.dataset.count || 0));
        }
      } else {
        const cart = await (await fetch(`${root}cart.js`)).json();
        updateCount(cart.item_count);
      }
    } catch (e) {
      try { const cart = await (await fetch(`${root}cart.js`)).json(); updateCount(cart.item_count); } catch (_) {}
    }
    if (open) openCart();
  }

  async function addToCart(items) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
    return json;
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not update cart');
    return json;
  }

  // Product form submit
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || T.cartType !== 'drawer') return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    btn && btn.classList.add('is-loading');
    const fd = new FormData(form);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    try {
      await addToCart([item]);
      await refreshCart(true);
    } catch (err) {
      toast(err.message, true);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  // Quick add, drawer qty, open/close
  document.addEventListener('click', async (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      qa.classList.add('is-loading');
      try {
        await addToCart([{ id: Number(qa.dataset.quickAdd), quantity: 1 }]);
        if (T.cartType === 'drawer') await refreshCart(true);
        else window.location.href = T.routes.cart;
      } catch (err) { toast(err.message, true); }
      qa.classList.remove('is-loading');
      return;
    }

    const opener = e.target.closest('[data-cart-open]');
    if (opener && T.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    const lineBtn = e.target.closest('[data-line-qty]');
    if (lineBtn) {
      e.preventDefault();
      const row = lineBtn.closest('[data-line-row]');
      row && row.classList.add('is-updating');
      try {
        await changeLine(Number(lineBtn.dataset.line), Number(lineBtn.dataset.lineQty));
        if (row && row.closest('#CartDrawer')) await refreshCart(false);
        else window.location.reload();
      } catch (err) { toast(err.message, true); row && row.classList.remove('is-updating'); }
    }
  });

  /* ---------- Product page ---------- */
  function initProducts() {
    $$('[data-product]').forEach((el) => {
      const jsonEl = $('[data-product-json]', el);
      if (!jsonEl || el.dataset.productInit) return;
      el.dataset.productInit = '1';
      const product = JSON.parse(jsonEl.textContent);
      const form = $('form[data-ajax-cart]', el);
      const idInput = form && form.querySelector('[name="id"]');
      const btn = form && form.querySelector('[type="submit"]');
      const btnLabel = btn && btn.querySelector('[data-label]');
      const priceEl = $('[data-price]', el);
      const sticky = $('[data-sticky-atc]');
      const stickyPrice = sticky && $('[data-sticky-price]', sticky);

      const selected = () => $$('[data-option]', el).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });

      const markAvailability = (opts) => {
        $$('[data-option]', el).forEach((fs, idx) => {
          $$('input', fs).forEach((input) => {
            const test = opts.slice(); test[idx] = input.value;
            const ok = product.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
            input.classList.toggle('is-unavailable', !ok);
          });
          const out = fs.querySelector('[data-selected-value]');
          if (out) out.textContent = opts[idx] || '';
        });
      };

      const update = () => {
        const opts = selected();
        markAvailability(opts);
        const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
        if (!v) {
          if (btn) btn.disabled = true;
          if (btnLabel) btnLabel.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        const priceHtml = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s> <span class="tag">Sale</span>` : '');
        if (priceEl) priceEl.innerHTML = priceHtml;
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (btn) btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.featured_media) {
          const target = $(`[data-media-id="${v.featured_media.id}"]`, el);
          const gallery = $('[data-gallery]', el);
          if (target && gallery) {
            if (window.innerWidth < 900) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft - 16, behavior: 'smooth' });
            else if (target !== gallery.firstElementChild) gallery.insertBefore(target, gallery.firstElementChild);
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };

      el.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) update(); });
      markAvailability(selected());

      // qty steppers
      $$('[data-qty-step]', el).forEach((b) => b.addEventListener('click', () => {
        const input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.qtyStep));
      }));

      // zoom on desktop
      $$('[data-zoom]', el).forEach((item) => {
        const img = item.querySelector('img');
        if (!img) return;
        item.addEventListener('click', () => {
          if (window.innerWidth < 900) return;
          item.classList.toggle('is-zoomed');
          if (!item.classList.contains('is-zoomed')) img.style.transformOrigin = '';
        });
        item.addEventListener('mousemove', (e) => {
          if (!item.classList.contains('is-zoomed')) return;
          const r = item.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        });
        item.addEventListener('mouseleave', () => { item.classList.remove('is-zoomed'); img.style.transformOrigin = ''; });
      });

      // mobile dots
      const gallery = $('[data-gallery]', el);
      const dots = $$('[data-dots] span', el);
      if (gallery && dots.length) {
        gallery.addEventListener('scroll', () => {
          const i = Math.round(gallery.scrollLeft / (gallery.firstElementChild.offsetWidth + 8));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        }, { passive: true });
      }

      // sticky add to cart
      if (sticky && btn) {
        const obs = new IntersectionObserver(([en]) => {
          sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
        obs.observe(btn);
        $('[data-sticky-submit]', sticky).addEventListener('click', () => {
          if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          form.requestSubmit ? form.requestSubmit(btn) : btn.click();
        });
      }
    });
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-sort]');
    if (!s) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Newsletter: scroll back to form after submit ---------- */
  function initNewsletter() {
    if (window.location.search.includes('customer_posted=true') || window.location.hash === '#newsletter') {
      const el = $('#newsletter');
      el && el.scrollIntoView({ block: 'center' });
    }
  }

  /* ---------- Boot ---------- */
  const boot = () => {
    initHeader();
    initReveal();
    initParallax();
    initRails();
    initCounters();
    initAgeGate();
    initProducts();
    initNewsletter();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initRails(e.target); initProducts(); initCounters(); });

  window.DripTheme = { refreshCart, openCart, closeCart, toast };
})();
